"use client";

import Lenis from "lenis";
import { useLenis } from "@/components/ui/lenisContext";
import { usePathname } from "next/navigation";
import { useEffect } from "react";

export default function SmoothScroll() {
  const lenisRef = useLenis();
  const pathname = usePathname();

  useEffect(() => {
    if (typeof window !== "undefined" && "scrollRestoration" in history) {
      history.scrollRestoration = "manual";
    }
  }, []);

  useEffect(() => {
    const lenis = lenisRef?.current;

    if (!lenis) {
      return;
    }

    lenis.start();
    lenis.scrollTo(0, { immediate: true });
  }, [lenisRef, pathname]);

  useEffect(() => {
    const lenis = new Lenis({
      duration: 2,
      easing: (time) => Math.min(1, 1.001 - Math.pow(2, -10 * time)),
      smoothWheel: true,
      wheelMultiplier: 0.8,
      touchMultiplier: 3,
      prevent: (node) => node?.closest?.("[data-lenis-prevent]") != null,
    });

    lenisRef.current = lenis;

    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }

    requestAnimationFrame(raf);

    return () => {
      lenis.destroy();
      lenisRef.current = null;
    };
  }, [lenisRef]);

  return null;
}
